export default (event) => {
  let isRightButtonClicked = false;

  if ('which' in event) {
    isRightButtonClicked = event.which == 3;
  } else if ('button' in event) {
    isRightButtonClicked = event.button == 2;
  }

  return isRightButtonClicked;
};
